<template>
  <div class="loading" :class="classObject">
    <div class="loading__svg">
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="30px"
        height="30px"
        viewBox="0 0 30 30"
        class="lds-ring"
      >
        <circle
          class="loading__svg-circle"
          cx="15"
          cy="15"
          fill="none"
          r="13"
          stroke="#b7b7b7"
          stroke-width="2"
          stroke-linecap="round"
          transform="rotate(216.567 15 15)"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            calcMode="linear"
            values="0 15 15;320 15 15;720 15 15"
            keyTimes="0;0.5;1"
            dur="1s"
            begin="0s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="stroke-dasharray"
            calcMode="linear"
            values="0 80; 70 80; 00 80"
            keyTimes="0;0.5;1"
            dur="1"
            begin="0s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
  /**
   * 対象範囲
   * @values single, whole
   */
    scope: {
    type: String,
    default: 'whole',
  },
  /**
   * 読み込み済みかどうか
   */
  loaded: {
    type: Boolean,
    required: true,
  },
})

const classObject = computed(() => {
  return {
    'scope-single': props.scope === 'single',
    'scope-whole': props.scope === 'whole',
    loaded: props.loaded,
  }
})

</script>

<style lang="scss" scoped>
.loading {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 20;
  display: flex;
  justify-content: center;
  align-items: center;

  .loading__svg {
    width: 3rem;
    height: 3rem;
    svg {
      width: 100%;
      height: 100%;
    }
  }

  &.scope-single {
    position: absolute;

    .loading__svg-circle {
      stroke: #808080;
    }
  }

  &.scope-whole {
    position: fixed;
    background-color: rgba(255, 255, 255, 0.7);

    .loading__svg-circle {
      stroke: #b7b7b7;
    }
  }

  &.loaded {
    display: none;
  }
}
</style>
